import type { Branded } from './types/Branded';

export type GraphPath = Branded<string, 'GraphPath'>;
